var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timesup-container"},[_vm._m(0),_c('div',{staticClass:"timesup"},[_c('h1',[_vm._v("End of game "+_vm._s(this.$route.query.game)+"!")]),_c('router-link',{attrs:{"to":_vm.path}},[_c('Button',{staticClass:"button",attrs:{"color":"orange","buttonText":"Next"}})],1)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer"},[_c('h3',[_vm._v("0:00")])])
}]

export { render, staticRenderFns }